import { createSlice } from '@reduxjs/toolkit';
import { apiCallBegan } from '../../../../store/middleware/apiActions';

const slice = createSlice({
	name: 'payments',
	initialState: {
		list: null,
		loading: false,
		lastFetch: null,
		updated: false,
		searchText: '',
		noPayments: false,
	},
	reducers: {
		paymentsRequestFailed: (payments, action) => {
			payments.loading = false;
		},
		paymentsRequested: (payments, action) => {
			payments.loading = true;
		},
		paymentsReceived: (payments, action) => {
			payments.list = action.payload.data;
			if (action.payload.data.length === 0) payments.noPayments = true;
			else payments.noPayments = false;
			payments.loading = false;
			payments.lastFetch = Date.now();
			payments.updated = false;
		},
		paymentsAdded: (payments, action) => {
			payments.list.unshift(action.payload);
			payments.updated = true;
			payments.noPayments = false;
		},
		paymentsDeleted: (payments, action) => {
			const index = payments.list.findIndex(s => s.id === action.payload.deletedId);
			payments.list.splice(index, 1);
			payments.updated = true;
			if (payments.list.length === 0) payments.nopPyments = true;
		},
		paymentsUpdated: (payments, action) => {
			const index = payments.list.findIndex(s => s.id === action.payload.id);
			payments.list[index] = action.payload;
			payments.updated = true;
			payments.noPayments = false;
		},
		searchTextChanged: (payments, action) => {
			payments.searchText = action.payload;
		},
		paymentsRelated: (payments, action) => {
			payments.updated = true;
		},
	},
});

export const {
	paymentsAdded,
	paymentsReceived,
	paymentsRequested,
	paymentsRequestFailed,
	searchTextChanged,
	paymentsUpdated,
	paymentsDeleted,
	paymentsRelated,
} = slice.actions;

export const loadPayments =
	(loanId = '', userId = '', type = 'user', page = 1, per_page = 160) =>
	(dispatch, getState) => {
		dispatch(
			apiCallBegan({
				api: 'hammurabi',
				method: 'POST',
				url: '/payments',
				params: {
					type,
					loan_id: loanId,
					user_id: userId,
					page,
					per_page,
				},
				onStart: paymentsRequested.type,
				onSuccess: paymentsReceived.type,
				onError: paymentsRequestFailed.type,
			})
		);
	};

export default slice.reducer;
